import {
  formatSellerProductListPrice,
  sellerProductCategoryLabel,
} from "../products/seller-product-mapper";

/**
 * Allowed `getProductsByStatus` payload.status values (from API).
 * "All" tab runs one query per status and merges results.
 */
export const APPROVAL_API_STATUS_VALUES = [
  "CREATED",
  "REJECTED",
  "APPROVED",
  "Out of Stock",
];

/** Tab key → single-query `payload.status` (not used for `all`). */
export const APPROVAL_TAB_API_STATUS = {
  pending: "CREATED",
  approved: "APPROVED",
  rejected: "REJECTED",
};

/**
 * Map API `status` string to UI badge / filter keys.
 */
export function normalizeApprovalTabStatus(apiStatus) {
  const raw = String(apiStatus ?? "").trim();
  if (!raw) return "pending";
  if (/out\s*of\s*stock/i.test(raw)) return "out-of-stock";
  const u = raw.toUpperCase();
  if (u.includes("REJECT")) return "rejected";
  if (u.includes("CREATED")) return "pending";
  if (u.includes("APPROV")) return "approved";
  return "pending";
}

function categorySlugForFilter(p) {
  const fromAlias = String(p?.alias ?? "").trim().toLowerCase();
  const known = new Set(["accessories", "fashion", "gadget", "home"]);
  if (known.has(fromAlias)) return fromAlias;
  const label = sellerProductCategoryLabel(p).toLowerCase();
  if (label.includes("fashion")) return "fashion";
  if (label.includes("gadget")) return "gadget";
  if (label.includes("home")) return "home";
  if (label.includes("access")) return "accessories";
  return "accessories";
}

function formatSubmittedAt(createdAt) {
  if (!createdAt) return "—";
  try {
    const d = new Date(createdAt);
    return d.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "—";
  }
}

export function mapProductByStatusItemToApprovalRow(p) {
  return {
    id: p._id,
    name: p.name || "—",
    sku: p.reference || "—",
    category: sellerProductCategoryLabel(p),
    categorySlug: categorySlugForFilter(p),
    price: formatSellerProductListPrice(p.price),
    stock: Number(p.quantityInStock) || 0,
    dateSubmitted: formatSubmittedAt(p.createdAt),
    approvalStatus: normalizeApprovalTabStatus(p.status),
    image: Array.isArray(p.images) ? p.images[0] : undefined,
    raw: p,
  };
}
